import { SubjectRole } from "../generated/graphql"

class Policy_OrganizationMembership {
    private constructor() {
        return
    }

    /**
     * Check if the role can update the activate/deactivate status of a subject
     * Only available to PPO Admin
     * @param role
     * @returns boolean
     */
    static canUpdateSubjectActivationStatus(role: SubjectRole) {
        return [SubjectRole.PpoAdmin].includes(role)
    }

    /**
     * Check if the role can only fetch active users
     * Org Admin or Org Member can only fetch active users
     * PPO Admin can fetch all users
     * @param role
     * @returns boolean
     */
    static canOnlyFetchActiveUsers(role: SubjectRole) {
        return [SubjectRole.OrgAdmin, SubjectRole.OrgMember].includes(role)
    }

    /**
     * Check if the role can have managed access
     * Only Org Member can have managed access
     * Org Admin and PPO Admin can not be set to have managed access
     * @param role
     * @returns boolean
     */
    static canHaveManagedAccessOrganizationMembership(role: SubjectRole) {
        return [SubjectRole.OrgMember].includes(role)
    }
}

export default Policy_OrganizationMembership
